import { render } from "./DeveloperItemTitle.vue?vue&type=template&id=10e93b62"
import script from "./DeveloperItemTitle.vue?vue&type=script&lang=js"
export * from "./DeveloperItemTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__